import * as negotiationV1 from './transactionProcessNegotiation';

export const transitions = {
  ...negotiationV1.transitions,
  CUSTOMER_CANCEL_BEFORE_SERVICE: 'transition/customer-cancel-before-service',
  CUSTOMER_CANCEL_SERVICE_DAY: 'transition/customer-cancel-service-day',
  PROVIDER_CANCEL_BEFORE_SERVICE: 'transition/provider-cancel-before-service',
  OPERATOR_REFUND_CUSTOMER_CANCELLATION: 'transition/operator-refund-customer-cancellation',
  OPERATOR_PAY_PROVIDER_CUSTOMER_CANCELLATION:
    'transition/operator-pay-provider-customer-cancellation',
  OPERATOR_CONFIRM_PARTIAL_CANCELLATION: 'transition/operator-confirm-partial-cancellation',
};

export const states = {
  ...negotiationV1.states,
  CANCELLATION_REVIEW: 'cancellation-review',
  CANCELLATION_REFUNDED: 'cancellation-refunded',
  CANCELLATION_PAID_TO_PROVIDER: 'cancellation-paid-to-provider',
  PARTIALLY_REFUNDED: 'partially-refunded',
};

export const graph = {
  ...negotiationV1.graph,
  id: 'default-negotiation/release-2',
  states: {
    ...negotiationV1.graph.states,
    [states.OFFER_ACCEPTED]: {
      on: {
        ...negotiationV1.graph.states[negotiationV1.states.OFFER_ACCEPTED].on,
        [transitions.CUSTOMER_CANCEL_BEFORE_SERVICE]: states.CANCELED,
        [transitions.CUSTOMER_CANCEL_SERVICE_DAY]: states.CANCELLATION_REVIEW,
        [transitions.PROVIDER_CANCEL_BEFORE_SERVICE]: states.CANCELED,
      },
    },
    [states.CANCELLATION_REVIEW]: {
      on: {
        [transitions.OPERATOR_REFUND_CUSTOMER_CANCELLATION]: states.CANCELLATION_REFUNDED,
        [transitions.OPERATOR_PAY_PROVIDER_CUSTOMER_CANCELLATION]:
          states.CANCELLATION_PAID_TO_PROVIDER,
        [transitions.OPERATOR_CONFIRM_PARTIAL_CANCELLATION]: states.PARTIALLY_REFUNDED,
      },
    },
    [states.CANCELLATION_REFUNDED]: { type: 'final' },
    [states.CANCELLATION_PAID_TO_PROVIDER]: { type: 'final' },
    [states.PARTIALLY_REFUNDED]: { type: 'final' },
  },
};

const v2Transitions = [
  transitions.CUSTOMER_CANCEL_BEFORE_SERVICE,
  transitions.CUSTOMER_CANCEL_SERVICE_DAY,
  transitions.PROVIDER_CANCEL_BEFORE_SERVICE,
  transitions.OPERATOR_REFUND_CUSTOMER_CANCELLATION,
  transitions.OPERATOR_PAY_PROVIDER_CUSTOMER_CANCELLATION,
  transitions.OPERATOR_CONFIRM_PARTIAL_CANCELLATION,
];

export const isRelevantPastTransition = transition =>
  v2Transitions.includes(transition) || negotiationV1.isRelevantPastTransition(transition);

export const isPrivileged = transition =>
  [
    transitions.CUSTOMER_CANCEL_BEFORE_SERVICE,
    transitions.CUSTOMER_CANCEL_SERVICE_DAY,
    transitions.PROVIDER_CANCEL_BEFORE_SERVICE,
    transitions.OPERATOR_CONFIRM_PARTIAL_CANCELLATION,
  ].includes(transition) || negotiationV1.isPrivileged(transition);

export const isCompleted = transition =>
  transition === transitions.OPERATOR_PAY_PROVIDER_CUSTOMER_CANCELLATION ||
  negotiationV1.isCompleted(transition);

export const isRefunded = transition =>
  [
    transitions.CUSTOMER_CANCEL_BEFORE_SERVICE,
    transitions.PROVIDER_CANCEL_BEFORE_SERVICE,
    transitions.OPERATOR_REFUND_CUSTOMER_CANCELLATION,
  ].includes(transition) || negotiationV1.isRefunded(transition);

export const isCustomerReview = negotiationV1.isCustomerReview;
export const isProviderReview = negotiationV1.isProviderReview;
export const getTransitionsWithMatchingOffers = negotiationV1.getTransitionsWithMatchingOffers;
export const isValidNegotiationOffersArray = negotiationV1.isValidNegotiationOffersArray;
export const isNegotiationState = negotiationV1.isNegotiationState;

export const statesNeedingProviderAttention = negotiationV1.statesNeedingProviderAttention;
export const statesNeedingCustomerAttention = negotiationV1.statesNeedingCustomerAttention;
